module.exports = {
  apiHost: "https://api.odesouthbank.sensoreal.app",
  assetsHost: "https://assets.odesouthbank.sensoreal.app",
  brandName: "",
  header: {
    text: { en: "Your Favourite Selections" },
    logo: "",
    companyLogo: "",
    color: "#fff",
  },
  langs: [
    { code: "en", dir: "ltr" },
    { code: "ar", dir: "rtl" },
  ],
  style: {
    primaryColor: "#000",
    textColor: "#fff",
  },
  contact: {
    website: "",
    address: "",
    phone: "",
    email: "",
  },
  links: {
    privacy: "",
    youtube: "",
    linkedin: "",
    twitter: "",
    instagram: "",
    facebook: "",
  },
};
